module.exports = __webpack_public_path__ + "static/media/boat-img-22.06428d26.jpg";